import { Filter, FilterPayload } from "../../domain/interfaces/Filter.interface";

export const getFilterPayload =
(params: Filter = {}): FilterPayload => {
  const filterPayload: any = {};

  for (const key in params) {
    const array = params[key];
    if (Array.isArray(array) && array[0] === '') {
      array.length > 1 ? array.shift() : delete params[key];
    }
  }

  params?.name && params.name.length
    ? (filterPayload.name = params.name) : undefined;

  params?.states && params.states.length
    ? (filterPayload.states = params.states.map((value: any) => value.id)) : undefined;

  params?.municipalities && params.municipalities.length
    ? (filterPayload.municipalities = params.municipalities.map((value: any) => value.id)) : undefined;

  params?.indigenousLands && params.indigenousLands.length
    ? (filterPayload.indigenousLands = params.indigenousLands.map((value: any) => value.id)) : undefined;

  params?.conservationUnits && params.conservationUnits.length
    ? (filterPayload.conservationUnits = params.conservationUnits.map((value: any) => value.id)) : undefined;

  params?.specialTerritories && params.specialTerritories.length
    ? (filterPayload.specialTerritories = params.specialTerritories.map((value: any) => ({
      id: value.id,
      name: value.name,
      category: value.category
    }))) : undefined;

  params?.status && params.status.length
    ? (filterPayload.status = params.status.map((value: any) => value.id)) : undefined;

  params.maintenance ? (filterPayload.awaitingMaintenanceStatus = params.maintenance) : undefined;

  params?.connectionType && params.connectionType.length
    ? (filterPayload.connectionTypes = params.connectionType.map((value: any) => value)) : undefined;

  params.contractType ? (filterPayload.contractType = params.contractType) : undefined;

  params?.partners && params.partners.length
  ? (filterPayload.partners = params.partners.map((value: any) => value.id)) : undefined;

  params?.energyKitModel && params.energyKitModel.length
  ? (filterPayload.energyKitModel = params.energyKitModel.map((value: any) => value)) : undefined;

  params?.dateStart
  ? (filterPayload.dateStart = params.dateStart.toISOString().slice(0, 10)) : undefined;

  params?.dateEnd
  ? (filterPayload.dateEnd = params.dateEnd.toISOString().slice(0, 10)) : undefined;

  params?.page
  ? (filterPayload.page = params.page) : undefined;

  params?.perPage
  ? (filterPayload.perPage = params.perPage) : undefined;

  params?.declaredTerritory && params.declaredTerritory.length
    ? (filterPayload.declaredTerritory = params.declaredTerritory.map((value: any) => value.id)) : undefined;

  params?.workGroups && params.workGroups.length
  ? (filterPayload.workGroups = params.workGroups.map((value: any) => value)) : undefined;

  params.association ? (filterPayload.association = params.association) : undefined;

  params?.routerModel && params.routerModel.length
  ? (filterPayload.routerModel = params.routerModel.map((value: any) => value)) : undefined;

  // console.log('filterPayload', filterPayload)
  return filterPayload;
}
